import React from "react";
import { Highlighter } from "lucide-react";
import { IconButton, Tooltip } from "@mui/material";
import { useScreenHighlight } from "../../Hooks/ScreenHighlight";

const buttonSx = {
  width: 38,
  height: 38,
  borderRadius: "50%",
  backgroundColor: "color-mix(in srgb, var(--portal-theme-color) 80%, transparent)",
  color: "var(--portal-theme-color)",
  border: "2px solid var(--portal-theme-color)",
  transition: "background-color 0.2s ease, color 0.2s ease",
  "&:hover": {
    backgroundColor: "color-mix(in srgb, var(--portal-theme-color) 88%, transparent)",
  },
  "&.is-active": {
    backgroundColor: "color-mix(in srgb, var(--portal-theme-color) 88%, transparent)",
    color: "var(--portal-theme-color)",
  },
};

export default function HighlightHeaderButton() {
  const highlight = useScreenHighlight();
  if (!highlight?.canHighlight) return null;

  const { toolbarOpen, strokes, toggleToolbar } = highlight;
  const active = toolbarOpen || strokes.length > 0;

  return (
    <Tooltip title={toolbarOpen ? "Hide highlight tools" : "Highlight (new)"}>
      <span className="highlight-header-btn">
        <IconButton
          onClick={toggleToolbar}
          sx={buttonSx}
          className={active ? "is-active" : ""}
          aria-label={toolbarOpen ? "Hide highlight tools" : "Highlight"}
          aria-pressed={toolbarOpen}
        >
          <Highlighter size={20} color="currentColor" />
        </IconButton>
        <span className="highlight-new-badge" aria-hidden>
          NEW
        </span>
      </span>
    </Tooltip>
  );
}
